import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Validators from './validators'
import { BaseManipStateFn, BaseTableState } from './base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    prepareNew () {
      if (!this.record.has('id')) {
        this.record.set('file_type', 'pprolls')
        this.record.set('lang', 'en')
        this.record.set('platform', 'flyprivate')
        this.record.set('slug', null)
        this.record.set('video_id', null)
        this.record.set('valid_from', moment().format(defaultConst.DATE_FORMAT))
        this.record.set('valid_to', defaultConst.DATE_MAX_DATE)
      }
    }

    onSaved (saved) {
      super.onSaved(saved)
      store.markDirty('pprolls_uploads')
    }

    requiredOptions = [
      'Countries',
      'FilmCargoLanguages',
      'Languages',
      'UploadTypes',
      'VideoId'
    ]

    timeRestriction = linkConst.LINK_PPROLLS_UPLOAD
    entityTitle = store.router && store.router.params && linkConst.LINKS_LIST[store.router.params.entityname]
    createtitle = store.__(this.entityTitle).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(this.entityTitle).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    hideSubmitOnly = true
    saveAndReturnText = store.__(defaultConst.TITLE_SUBMIT)

    validators = {
      lang: Validators.isMandatory(store),
      regions: [
        Validators.isMandatory(store),
        Validators.regionTest(store)
      ],
      valid_from: [
        Validators.isMandatoryDate(store),
        Validators.isValidFromTo(store)
      ],
      valid_to: [
        Validators.isMandatoryDate(store),
        Validators.isValidFromTo(store)
      ],
      _global: (vals) => {
        const file = vals.get('file')
        if (file) {
          file.name && vals.set('original_filename', file.name)
          file.size && vals.set('final_length', file.size)
          vals.set('state', 'waiting')
        }
        if (file && file.type && file.type !== 'video/mp4') {
          return [store.__('This is not valid video/mp4 file')]
        }
      }
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'state', 'validity', 'regions',
      'lang', 'final_length', 'original_filename', 'valid_from', 'valid_to'
    ]

    headertitles = [
      store.__('ID'), store.__('state'), store.__('validity'),
      store.__('regions'), store.__('language'), store.__('original size'), store.__('original filename'),
      store.__('valid from'), store.__('valid to')
    ]

    title = store.__(linkConst.LINK_PPROLLS_UPLOAD_TITLE)
    timeRestriction = linkConst.LINK_PPROLLS_UPLOAD
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_PPROLLS_UPLOAD]

    requiredOptions = [
      'Countries',
      'FilmCargoLanguages',
      'Languages',
      'UploadTypes',
      'VideoId'
    ]

    init () {
      return super.init()
    }
  }

  return { ManipState, TableState }
}
